module.exports = __webpack_public_path__ + "static/media/yellow-ladys-slipper-pair-100603.fc719d2d.jpg";